module.exports = __webpack_public_path__ + "montserrat-black-webfont.bb6195a0bea6e9894dc2.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-black-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-black-webfont.woff2
// module chunks = styles